export default __webpack_public_path__ + "static/media/roboqube.7dcb4a24.png";